export const IS_STORYBOOK = Boolean(process.env.STORYBOOK)
export const IS_JEST = process.env.APP_ENV === 'test'
export const IS_DEVELOPMENT = process.env.APP_ENV === 'development'
export const IS_PRODUCTION = process.env.APP_ENV === 'production'
// eslint-disable-next-line no-restricted-globals
export const IS_NODE = typeof window === 'undefined'
export const IS_BROWSER = !IS_STORYBOOK && !IS_JEST && !IS_NODE
